<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-03-23 23:09:00
-->
<template>
    <config-wrap :title="label">
        <div class="mb10 f-grey f12">{{ mOptions.note }}</div>
        <div class="nav">
            <div class="nav-add mb10" @click="openDialog">编辑富文本</div>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" top="5vh"
            width="1200px">
            <FaRichText style="width: 100%;height: 500px" v-model="content" />

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="done">确 定</el-button>
            </span>
        </el-dialog>
    </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";


export default {
    name: "SchemaRichText",

    mixins: [schemaMixin],

    components: {
    },

    props: {
        label: {
            type: String,
            default: "",
        },
        schema: {
            type: Object,
            default: () => { },
        },
    },

    inject: ["control"],

    data() {
        return {
            dialogVisible: false,
            dialogTitle: "编辑富文本",
            content: '',
        };
    },

    watch: {
        dialogVisible(val) {
            if (!val) {
                this.content = '';
            }
        }
    },

    methods: {
        openDialog() {
            this.dialogVisible = true;
            this.content = this.control.curWidget.attrs;
        },

        done() {
            this.control.curWidget.attrs = this.content;
            this.content = '';
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .config-item {
    margin-bottom: 10px !important;
}

.p10 {
    padding: 10px;
}

.ml-auto {
    margin-left: auto;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-end {
    justify-content: flex-end;
}
</style>